module.exports = __webpack_public_path__ + "7b1ecb55796b9beb0e1af6c1278f6b7a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-8.png
// module id = 1789
// module chunks = 0